import { Textarea as BraidTextArea } from 'braid-design-system';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';

import { parseLabel } from '../parseLabel.tsx';
import type { TextFormFields } from '../types.ts';
import { createTextFieldValidationRules } from '../validation.ts';

interface TextAreaProps {
  element: TextFormFields;
}

export const TextArea = ({ element }: TextAreaProps) => {
  const label = useMemo(
    () => parseLabel(element.id, element.label, element.labelLinks),
    [element.id, element.label, element.labelLinks],
  );
  return (
    <Controller
      key={element.id}
      name={element.id}
      rules={createTextFieldValidationRules(element)}
      render={({ field, fieldState }) => (
        <BraidTextArea
          label={label}
          placeholder={element.placeholder}
          secondaryLabel={element.secondaryLabel}
          onChange={field.onChange}
          value={field.value}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
        />
      )}
    />
  );
};
